'use strict';

function controller ($scope, dealerChatService, viewport, activeEngage, pageStateService, leadFormService) {

    const ctrl = this;
    ctrl.name = 'dealerChatLink';

    ctrl.buttonEnabled = true;
    ctrl.isActiveEngageEnabled = false;

    ctrl.$onInit = function () {
        ctrl.ctaPosition = ctrl.chatPosition === "dealer-cta" || ctrl.chatPosition === "elf-cta";
        ctrl.headerPosition = ctrl.chatPosition === "vdp-header";
        ctrl.pagePosition = ctrl.chatPosition === "dealer-data";
        ctrl.elfPosition = ctrl.chatPosition === "elf-cta";
        ctrl.hasChatDisabled = ctrl.hasChatEnabled == 'false';

        if (dealerChatService.isActiveEngageEnabled()) {
            ctrl.isActiveEngageEnabled = true;
            ctrl.buttonEnabled = activeEngage.isActiveEngageReady();
            ctrl.setShowButtons();

            $scope.$on(activeEngage.activeEngageReadyEvent, () => {
                ctrl.buttonEnabled = true;
            });
        } else {
            if (ctrl.isDealerInspire === "true") {
                if ((ctrl.linkLocation === 'modal' || ctrl.linkLocation === 'header') && !viewport.isMobile()) {
                    ctrl.showDealerInspire = true;
                    ctrl.showVdpStickyHeaderChat = !ctrl.hasChatDisabled && ctrl.headerPosition;
                } else if (ctrl.linkLocation === 'tymodal') {
                    ctrl.showDealerInspire = true;
                    if (!viewport.isMobile()) {
                        ctrl.showTyModalChat = true;
                        ctrl.showTyModalText = false;
                    } else {
                        ctrl.showTyModalChat = false;
                        ctrl.showTyModalText = true;
                    }
                } else {
                    ctrl.showTyModalChat = false;
                    ctrl.showTyModalText = false;
                    ctrl.showDealerInspire = false;
                }
            } else {
                ctrl.showDealerInspire = false;
                ctrl.showVdpChatOnline = false;
            }
        }
    };

    ctrl.setShowButtons = function() {
        ctrl.showVdpChatOnline = ctrl.ctaPosition;
        ctrl.showVdpStickyHeaderChat = !ctrl.hasChatDisabled && ctrl.headerPosition;
        ctrl.showDealerDataChat = ctrl.pagePosition;
        ctrl.showElfVdpChatOnline = ctrl.elfPosition;
    };

    ctrl.openChat = function () {
        if (dealerChatService.isActiveEngageEnabled()) {
            let payload = {};
            payload.listingId = ctrl.listingId;
            payload.vehicleMake = ctrl.makeName;
            payload.vehicleModel = ctrl.modelName;
            payload.vehicleYear = ctrl.modelYear;
            payload.vehicleStockNumber = ctrl.stockNumber;
            payload.vehicleVin = ctrl.vin;
            payload.advertiserId = ctrl.customerId;

            activeEngage.launchChat(payload);
        }
        dealerChatService.fireChatPageStateEvent();
    };

    ctrl.openEmbeddedChat = function () {
        leadFormService.setDefaultToChatTab(true);
    };
}

controller.$inject = ['$scope', 'dealerChatService', 'viewport', 'activeEngage', 'pageStateService', 'leadFormService'];

export default controller;
